<template>
  <div class="stats-card" :class="variant">
    <div class="stats-content">
      <span class="stats-label">{{ label }}</span>
      <span class="stats-value">{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatsCard",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      required: true,
    },
    variant: {
      type: String,
      default: "primary",
      validator: (val) => ["primary", "success", "warning"].includes(val),
    },
  },
};
</script>

<style lang="scss" scoped>
.stats-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px 24px;
  border-left: 4px solid #1e40af;
  min-width: 180px;

  &.primary {
    border-left-color: #1e40af;
  }

  &.success {
    border-left-color: #059669;
  }

  &.warning {
    border-left-color: #d97706;
  }
}

.stats-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stats-label {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
}

.stats-value {
  font-size: 28px;
  font-weight: 700;
  color: #111827;
}
</style>
